const GeradorAsoEnum = {
        INTERNO: 'INTERNO',
        SOC: 'SOC'
    }

export default GeradorAsoEnum;
